// Centralized support URLs for configuration assistance
export const CALENDLY_ONBOARDING_URL = 'https://calendly.com/maxdmnt/piktable';
